module.exports = __webpack_public_path__ + "img/logo_whatsapp.acf51bc4.svg";